<template>
  <div class="Ucircle">
    <!-- 自己的空间 -->
    <div class="contentWidth of_h mt20"
         v-if=" !this.userId">
      <div class="bd of_h">
        <ul class="clearFix"
            v-if="loading_bool">
          <Loading :loading_bool="loading_bool"></Loading>
        </ul>

        <ul class="clearFix"
            v-if="!loading_bool && own_circle_data.records.length !==0">
          <li class="fc_l"
              v-for="(item,index) in own_circle_data.records"
              :key="index">
            <!-- 
            <img class="boxbg fade_image_out"
                 :src="item.cover">
            <a href="javascript:;"
               @click="on_ucenter(item.userId)"
               class="Headimage">
              <div class="hd_img">
                <img :src="item.logo">
              </div>
            </a>

            <a href="javascript:;"
               @click="on_ucenter(item.userId)"
               class="name">{{item.name}}</a> -->
            <router-link :to="'/circleDetail/'+item.id">
              <img class="boxbg fade_image_out"
                   :src="item.cover">
            </router-link>
            <!-- target="_blank"  -->
            <router-link :to="'/circleDetail/'+item.id"
                         class="Headimage">
              <div class="hd_img">
                <img :src="item.logo">
              </div>
            </router-link>

            <router-link :to="'/circleDetail/'+item.id"
                         class="name">{{item.name}}</router-link>

            <div class="info">{{item.description}}</div>
            <div class="statistics">
              <span class="state">成员<strong>{{item.userNum}}</strong></span>
              <span class="middle">|</span>
              <span class="state">作品<strong>{{item.topicNum}}</strong></span>
            </div>

            <!-- 取消加入圈子 -->
            <div class="_width join_conter"
                 v-if="item.code == 1">
              <div class="join_null"
                   @click="join_quan(item.id,1)"
                   v-ripple="'rgba(255, 255, 255, 0.45)'">
                ✓已加入</div>

              <div class="join top"
                   @click="join_quan(item.id,1)"
                   v-ripple="'rgba(255, 255, 255, 0.45)'">
                取消加入</div>
            </div>
            <!-- 加入圈子 -->
            <div class="_width join_conter"
                 v-if="item.code == 0">
              <div class="join bottom"
                   @click="join_quan(item.id,0)"
                   v-ripple="'rgba(255, 255, 255, 0.45)'">+ 加入</div>
            </div>

          </li>
        </ul>

        <div class="null_data"
             v-if="!loading_bool && own_circle_data.records.length ==0">
          <img src="@/assets/image/common/null_data.png"
               alt="">
          <p>暂无圈子...</p>
        </div>

      </div>
      <div class="Ufollowspage">
        <el-pagination background
                       :hide-on-single-page="true"
                       layout="
                       prev,
                       pager,
                       next"
                       :current-page="page.current_page"
                       @current-change="handleCurrentChange_own"
                       :page-size="page.PageSize"
                       :total="page.total"></el-pagination>
      </div>
    </div>

    <!-- 别人的空间 -->
    <div class="contentWidth of_h mt20"
         v-if="this.userId">
      <div class="bd of_h">
        <ul class="clearFix"
            v-if="loading_bool">
          <Loading :loading_bool="loading_bool"></Loading>
        </ul>

        <ul class="clearFix"
            v-if="!loading_bool && other_circle_data.records.length!==0">
          <li class="fc_l"
              v-for="(item,index) in other_circle_data.records"
              :key="index">
            <router-link :to="'/circleDetail/'+item.id">
              <img class="boxbg"
                   :src="item.cover">
            </router-link>
            <!-- target="_blank"  -->
            <router-link :to="'/circleDetail/'+item.id"
                         class="Headimage">
              <div class="hd_img">
                <img :src="item.logo">
              </div>
            </router-link>

            <router-link :to="'/circleDetail/'+item.id"
                         class="name">{{item.name}}</router-link>

            <div class="info">{{item.description}}</div>
            <div class="statistics">
              <span class="state">成员<strong>{{item.userNum}}</strong></span>
              <span class="middle">|</span>
              <span class="state">作品<strong>{{item.topicNum}}</strong></span>
            </div>

            <!-- 加入圈子 -->
            <!-- <div class="join"
                 @click="join_quan(item.id,0)"
                 v-if="item.code == 0"
                 v-ripple="'rgba(255, 255, 255, 0.45)'">+ 加入</div>
            <div class="join_null"
                 v-if="item.code == 1"
                 @click="join_quan(item.id,1)"
                 v-ripple="'rgba(255, 255, 255, 0.45)'">已加入</div> -->

            <!-- 取消加入圈子 -->
            <div class="_width join_conter"
                 v-if="item.code == 1">
              <div class="join_null"
                   @click="join_quan(item.id,1)"
                   v-ripple="'rgba(255, 255, 255, 0.45)'">已加入</div>
              <div class="join top"
                   @click="join_quan(item.id,1)"
                   v-ripple="'rgba(255, 255, 255, 0.45)'">取消加入</div>
            </div>
            <!-- 加入圈子 -->
            <div class="_width join_conter"
                 v-if="item.code == 0">
              <div class="join bottom"
                   @click="join_quan(item.id,0)"
                   v-ripple="'rgba(255, 255, 255, 0.45)'">+ 加入</div>
            </div>

          </li>
        </ul>

        <div class="null_data"
             v-if="!loading_bool && other_circle_data.records.length==0">
          <img src="@/assets/image/common/null_data.png"
               alt="">
          <p>暂无圈子...</p>
        </div>

      </div>
      <div class="Ufollowspage">
        <el-pagination background
                       :hide-on-single-page="true"
                       layout="prev, pager, next"
                       :current-page="page2.current_page"
                       @current-change="handleCurrentChange_other"
                       :page-size="page2.PageSize"
                       :total="page2.total"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/loading/loading.vue'
import {
  me_circle,
  ta_circle,
  join_circle,
  go_out_circle
} from '@/utils/api/ucenter.js' //别人的圈子  自己的圈子
import { Info } from '@/utils/api/login.js'

export default {
  name: 'Ucircle',
  data () {
    return {
      loading_bool: false, //加载loading
      own_circle_data: [], //自己圈子数据
      other_circle_data: [], //别人圈子数据
      // 自己
      page: {
        total: 0,
        current_page: 1,//默认第一页
        PageSize: 8,
      },

      // 别人
      page2: {
        total: 0,
        current_page: 1,//默认第一页
        PageSize: 8,
      },
      isLogin_user: {},
      userId: '',
      myid: '',
    }
  },
  created () {
    this.is_login();//是否登陆
    this.router_url = this.$route.fullPath;//当前地址url
    this.myid = sessionStorage.getItem("id");

    let userId = this.$route.params && this.$route.params.id;
    this.userId = userId;
    if (this.userId) {
      let params = {
        userId: this.userId,
        current: this.page2.current_page,
        size: this.page2.PageSize,
      }
      this.others_circle(params) //别人圈子
    } else {
      let params = {
        current: this.page.current_page,
        size: this.page.PageSize,
      }
      this.own_circle(params) //自己圈子
    }
  },
  methods: {

    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        if (this.isLogin == true) {
          this.isLogin_user = data.user
        }
        // if (this.isLogin == false) {
        //   sessionStorage.setItem('router_url', this.router_url)//活动详情
        //   this.$router.push(
        //     {
        //       path: '/login/?state=' + 1,
        //     }
        //   )
        // }
      })
    },

    //自己圈子数据
    own_circle (name) {
      this.loading_bool = true;
      me_circle(name).then((res) => {
        let data = res.data;
        this.own_circle_data = data.data

        //分页
        this.page.total = data.data.total; //全部数据
        this.page.current_page = data.data.current; //默认第一页
        this.page.PageSize = data.data.size //每页条数
        this.loading_bool = false;

      })
    },



    //别人圈子数据
    others_circle (name) {
      this.loading_bool = true;
      ta_circle(name).then((res) => {
        let data = res.data;
        this.other_circle_data = data.data
        //分页
        this.page2.total = data.data.total; //全部数据
        this.page2.current_page = data.data.current; //默认第一页
        this.page2.PageSize = data.data.size //每页条数
        // console.log(data);
        this.loading_bool = false;

      })
    },


    // 点击自己分页
    handleCurrentChange_own (val) {
      let params_data = {
        current: val,
        size: this.page.PageSize,
      }
      this.own_circle(params_data); ///刷新粉丝列表
      window.scrollTo(0, 430);
    },
    // 点击别人分页
    handleCurrentChange_other (val2) {
      let params_data2 = {
        userId: this.userId,
        current: val2,
        size: this.page2.PageSize,
      }

      this.others_circle(params_data2); ///刷新粉丝列表
      window.scrollTo(0, 430);
    },

    // 加入圈子事件
    join_quan (circleId, type) {
      let params = {
        circleId: circleId,
        userId: this.userId,
        // userId: '83056ebdfce64888a97c2c9fe2529228',
      }
      if (type == 0) {
        // 未加入的还是
        this.join_circle_data(params);
      } else if (type == 1) {
        // 已经加入
        this.qx_go_out_circle(params);

      }
    },

    // 加入圈子
    join_circle_data (name) {
      // 未登录就去登录
      if (this.isLogin == true) {
        join_circle(name).then((res) => {
          let data = res.data;
          if (data.code == 200) {
            if (!this.userId) {
              // 自己
              let params2 = {
                current: this.page.current_page,
                size: this.page.PageSize,
              }
              this.own_circle(params2);
              this.$emit('update_data', true) //传父组件 让腹组件更新导航数据
            } else {
              // 别人
              let params_data = {
                userId: this.userId,
                current: this.page2.current_page,
                size: this.page2.PageSize,
              }
              this.others_circle(params_data);
              this.$emit('update_data', true) //传父组件 让腹组件更新导航数据
            }
          } else if (data.code !== 200) {
            this.$message({
              message: data.message,
              type: 'error'
            });
          }
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },

    // 取消圈子
    qx_go_out_circle (name) {
      // 未登录就去登录
      if (this.isLogin == true) {
        go_out_circle(name).then((res) => {
          let data = res.data;
          if (data.code == 200) {
            if (!this.userId) {
              // 自己
              let params2 = {
                current: this.page.current_page,
                size: this.page.PageSize,
              }
              this.own_circle(params2);
              this.$emit('update_data', true) //传父组件 让腹组件更新导航数据

            } else {
              // 别人
              let params_data = {
                userId: this.userId,
                current: this.page2.current_page,
                size: this.page2.PageSize,
              }
              this.others_circle(params_data);
              this.$emit('update_data', true) //传父组件 让腹组件更新导航数据
            }
          } else if (data.code !== 200) {
            this.$message({
              message: data.message,
              type: 'error'
            });
          }

        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },

  },

  components: {
    Loading,
  },
}
</script>

<style scoped>
.bd ul li:nth-child(4n) {
  margin-right: 0 !important;
}

.join_conter {
  position: relative;
  overflow: hidden;
}

.top {
  height: 0.3rem !important;
  position: absolute !important;
  top: 0.32rem;
  left: 0.175rem;
  width: 0.259rem;
  transition: all 0.3s;
  background: #f9fafb !important;
  border: 1px solid #f9fafb !important;
  color: #d3011a !important;
  box-sizing: border-box;
}

.join_conter:hover .top {
  top: 0.01rem !important;
}
</style>

<style lang="scss" scoped="scoped">
div.Ucircle {
  margin-bottom: 20px;

  div.contentWidth {
    background: #fff;
    border-radius: 5px;
    // padding-top: 10px;
    padding-bottom: 20px;
  }

  div.bd {
    padding: 0 20px;
    padding-bottom: 20px;

    ul {
      // width: 1280px;
      // margin-top: -10px;
      // padding-bottom: 20px;
      min-height: 600px;
      width: 100%;
      margin-top: 0px;
      padding-bottom: 20px;

      // display: flex;
      // flex-wrap: wrap;
      // justify-content: space-between;
      li {
        width: 295px;
        margin-top: 20px;
        transition: all 0.3s;
        height: 322px;
        border-radius: 5px;
        // background: #fff;
        border: 1px #f1f1f1 solid;
        margin-right: 25px;
        cursor: pointer;
        position: relative;
        margin-bottom: 10px;

        &:hover {
          box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
        }

        img.boxbg {
          display: block;
          width: 100%;
          height: 128px;
          border-radius: 10px 10px 0 0;
          object-fit: cover;
        }

        .Headimage {
          display: block;
          width: 100%;
          height: 76px;
          margin-top: -55px;
          position: relative;
          display: flex;
          justify-content: center;

          .hd_img {
            display: block;
            width: 76px;
            height: 76px;
            float: left;
            border-radius: 50%;
            backdrop-filter: saturate(180%) blur(20px);
            -webkit-backdrop-filter: blur(20px);
            background-color: rgba(255, 255, 255, 0.7);
            border: 3px rgba(255, 255, 255, 0.5) solid;
            margin: 0 auto;
            overflow: hidden;

            box-sizing: border-box;
          }

          img {
            width: 100%;
            height: 100%;
            float: left;
            border-radius: 50%;
            overflow: hidden;
          }
        }
        .name {
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
          text-align: center;
          padding: 0 10%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          box-sizing: border-box;
          word-break: break-all;
          color: #333;
        }

        div.info {
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-size: 14px;
          color: #888;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          box-sizing: border-box;
          word-break: break-all;
          padding: 0 10%;
        }

        div.statistics {
          width: 260px;
          margin: 0 auto;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-top: 1px #eee solid;
          border-bottom: 1px #eee solid;

          span.state {
            padding: 0 10px;
            color: #999;
            font-size: 14px;

            strong {
              padding: 0 5px;
              font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei",
                "HanHei SC", "Helvetica Neue", "Open Sans", Arial,
                "Hiragino Sans GB", "微软雅黑", STHeiti, "WenQuanYi Micro Hei",
                SimSun, sans-serif;
            }
          }
        }

        div.join {
          width: 260px;
          margin: 0 auto;
          margin-top: 10px;
          -webkit-transition: all 0.3s;
          transition: all 0.3s;
          line-height: 30px;
          height: 0.32rem;
          text-align: center;
          border: 1px #d3011a solid;
          color: #d5182e;
          border-radius: 3px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
        }

        div.join:hover {
          background: #d3011a;
          color: #fff;
        }

        div.join_null {
          width: 260px;
          margin: 0 auto;
          margin-top: 10px;
          transition: all, 1s;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #dcddde;
          background: #f9fafb;
          color: #888;
          border-radius: 3px;
        }

        // div.join_null:hover {
        //   background: #fff;
        //   color: #000;
        // }
      }
    }
  }

  div.Ufollowspage {
    display: flex;
    margin-top: 40px;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ucenter/Ucircle.vue